<template>
    <div><!-- 作廢招標及報價 -->

        <!-- Modal -->
        <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        {{$t('QuoteInfo_Vue.Invalid')}}
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="field">
                                    <div class="field-name">{{$t('QuoteInfo_Vue.InvalidReason')}}</div>
                                    <textarea v-model="invalidContent"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-gray" data-dismiss="modal">{{$t('Buttons.Cancel')}}</button>
                        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="confirmData">{{$t('Buttons.Ok')}}</button>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {   
            invalidContent: ''        
        }
    },
    props : {                
    },
    methods: {
        confirmData (){
            if(!this.invalidContent){
                this.$alert('需填寫作廢原因!','警告',{type: 'warning'});
                return;
            }
            this.$emit('finishInvalid' , this.invalidContent);
            this.invalidContent = ''; //清空
        }
    },
}
</script>

<style lang="scss" scoped>
.btn-blue {
    color: #fff !important;
    font-size: .85em;
    background: #343b55;
}

.btn-gray {
    background-color: gray;
    color: white;
}

.modal-body .alert-box .alert-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: normal;
}

.modal-body {
    background-color: #ECEEF6;
}

.field-name {
    font-weight: bolder;
    color: #000;
}

</style>